export const setMessages = (context, payload) => {
  context.commit('setMessages', payload)
}

export const resetMessages = (context, payload) => {
  context.commit('setMessages', {})
}
